export const studentList = [
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAS',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAS',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAS',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COE',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COE',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'NA',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COE',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAA',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAA',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAS',
    college: 'COS',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAA',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COE',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAA',
    college: 'COS',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COE',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COE',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COE',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'NA',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COE',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAS',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAS',
    college: 'COE',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COS',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAS',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COE',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAS',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COE',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COE',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'NA',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAS',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAA',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAS',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAA',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COE',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COE',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'NA',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COE',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COE',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAS',
    college: 'COS',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAA',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COE',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAS',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAS',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAS',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAA',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAA',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAA',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAA',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAS',
    college: 'COA',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COE',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAS',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAS',
    college: 'COA',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAA',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COE',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAA',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAS',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAS',
    college: 'COB',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAS',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAS',
    college: 'COB',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAS',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAA',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COE',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAS',
    college: 'COS',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COE',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAA',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COE',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAA',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COE',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COE',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAS',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COE',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COE',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAA',
    college: 'COA',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COE',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COE',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COE',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COE',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAS',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COE',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COE',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAS',
    college: 'COA',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAS',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COE',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COE',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COE',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COE',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COE',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAS',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COE',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAS',
    college: 'COA',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAS',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COE',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COE',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COE',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAS',
    college: 'COS',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COE',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COE',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COE',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COE',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COE',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COE',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COE',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAS',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COE',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COE',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAA',
    college: 'COA',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAS',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COE',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAS',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAA',
    college: 'COA',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COE',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COE',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAS',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAS',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COE',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COE',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAS',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAS',
    college: 'COA',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAA',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAS',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COE',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COE',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAS',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COE',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAA',
    college: 'COE',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAS',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAS',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAA',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COE',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COE',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAS',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAS',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAA',
    college: 'COE',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COE',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAS',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAS',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COE',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COE',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COE',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAA',
    college: 'COE',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAS',
    college: 'COA',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COE',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAS',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAS',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COE',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COE',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAS',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAS',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COE',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAS',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COE',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAA',
    college: 'COH',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAS',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COE',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAS',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAA',
    college: 'COB',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAS',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAS',
    college: 'COB',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COE',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAS',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAS',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAA',
    college: 'COA',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAS',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAA',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAS',
    college: 'COE',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAA',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAA',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAS',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COE',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAA',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAA',
    college: 'COB',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAS',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAA',
    college: 'COA',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAA',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAA',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAS',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAA',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COE',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COE',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COE',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAS',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAA',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2023,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COE',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COE',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COE',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAS',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COE',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COE',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAA',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COE',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COE',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COE',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COE',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COE',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COE',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COE',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COE',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COE',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAA',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAS',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COE',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'NA',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COB',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COE',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COE',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COE',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAA',
    college: 'COA',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COE',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COA',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COE',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAS',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COE',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAS',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COE',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COE',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAS',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAS',
    college: 'COS',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAS',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COE',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COE',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COE',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAA',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAS',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAA',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAS',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAS',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAS',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAS',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COE',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COE',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAA',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COE',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COB',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAA',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAS',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'NA',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAA',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAS',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COE',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAA',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAA',
    college: 'COE',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COE',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAA',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COE',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'NA',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAS',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAS',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAS',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAA',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAS',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAA',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAS',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAS',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COE',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAA',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAS',
    college: 'COA',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAS',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAA',
    college: 'COB',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAS',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'NA',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAS',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FTIC',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAS',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAA',
    college: 'COS',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAA',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COB',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'NA',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COE',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAS',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAA',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAS',
    college: 'COB',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COA',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAA',
    college: 'COS',
    dropout_risk: 'High Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COE',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COE',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COS',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COS',
    dropout_risk: 'Medium Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'NA',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAA',
    college: 'COB',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'Low Risk',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'NA',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'NA',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'NA',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'NA',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'NA',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAA',
    college: 'COH',
    dropout_risk: 'NA',
  },
  {
    cohort: 2024,
    admit_type: 'OtherAS',
    college: 'COH',
    dropout_risk: 'NA',
  },
  {
    cohort: 2024,
    admit_type: 'FCSAS',
    college: 'COH',
    dropout_risk: 'NA',
  },
];
